import forms from '@wwdev/forms';
import Zipcode from '@wwdev/zipcode';
import Form from './Form.js';
import { configureValidation } from './config.js';

configureValidation(forms);

new Form({ scope: 'form.below' });
new Form({ scope: 'form.text_inside_input_field', floating: true });

forms.init('form');
Zipcode.init();
